<script>
    import {mapStore} from '@js/stores/mapStore';

    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';
    import AnalyticsService from '@js/modules/analyticsService';

    const TimeToStartModal = () => import('@js/components/maps/timeToStart/TimeToStartModal.svelte');

    const {
        rideId
    } = $props();

    let isShowTimeToStart = $state(false);

    const _handleShowTimeToStart = () => {
        isShowTimeToStart = true;

        AnalyticsService.trackTimeToStartModalShow();
    };
</script>

{#if $mapStore.currentDistance || rideId}
    <div class="flex items-center justify-center flex-col">
        <button class="button-primary-contained"
                onclick={_handleShowTimeToStart}>
            {I18n.t('js.maps.time_to_start.button')}
        </button>

        <div class="p-2 text-xs leading-3 text-center text-gray-500 italic">
            {I18n.t('js.maps.time_to_start.helper')}
        </div>
    </div>
{/if}

{#if isShowTimeToStart}
    {#await TimeToStartModal() then TimeToStartModalLoader}
        {@const
            TimeToStartModalComponent = TimeToStartModalLoader.default}
        <TimeToStartModalComponent bind:isModalOpen={isShowTimeToStart}/>
    {/await}
{/if}

{#if $mapStore.timeToStartDuration}
    <div class="flex items-center justify-center flex-col my-2">
        <div class="flex items-center justify-center my-2">
            {I18n.t('js.maps.time_to_start.duration')}
        </div>

        <div class="flex items-center justify-center my-2 font-bold text-lg">
            {Computation.formatDuration($mapStore.timeToStartDuration, {
                withSeconds: false,
                withLeadingZero: false
            })}
        </div>
    </div>
{/if}
